import './Footer.css';

const Footer = () => {

    return (
        <footer id="pageFooter">
            <a href='https://www.gateworld.net/wiki/Comtrya' className='footerClick' target='_'><p>Comtrya!</p></a>
            <p>This is the bottom.</p>
        </footer>
    )
}

export default Footer;